import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { HeartHandshake, X } from "lucide-react";

// Customer Confidence announcement — DORMANT until the platform sets
// cc_announcement_enabled (off by default, staging + production).
// Guarantees: eligible company admins only (owner/admin, CC active, flag on);
// shown once — dismissal is persisted server-side per user; inline in the
// content flow so it never covers navigation or project content; crews never
// see it; hidden entirely while the feature is disabled.
export default function CcAnnouncementBanner() {
  const { t } = useTranslation();
  const { user } = useAuth();
  const navigate = useNavigate();
  const [gone, setGone] = useState(false);
  const [busy, setBusy] = useState(false);

  if (gone || !user?.cc_announce) return null;

  const dismiss = async () => {
    setBusy(true);
    try { await api.post("/cc/announcement/dismiss"); } catch { /* dismiss locally regardless */ }
    setGone(true);
  };

  return (
    <div data-testid="cc-announcement"
      className="mb-6 flex items-center gap-3 rounded-xl border border-brand/25 bg-brand/5 px-4 py-3">
      <HeartHandshake className="h-4 w-4 shrink-0 text-brand" />
      <span className="text-sm font-semibold text-slate-700">{t("cc_announce_text")}</span>
      <button onClick={() => navigate("/app/settings")} data-testid="cc-announce-learn"
        className="ml-auto min-h-[44px] rounded-full bg-brand px-4 py-1.5 text-xs font-bold text-white active:scale-95">
        {t("cc_announce_learn")}
      </button>
      <button onClick={dismiss} disabled={busy} aria-label={t("close")} data-testid="cc-announce-dismiss"
        className="flex min-h-[44px] min-w-[44px] items-center justify-center rounded-lg text-slate-400 hover:text-slate-600">
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
